import { withFirebase } from "../Firebase";
import "react-big-calendar/lib/css/react-big-calendar.css";
import React, { Component } from "react";

import {
  ButtonGroup,
  Button,
  Intent,
  Tab,
  Tabs,
  Popover,
  Classes,
  Icon,
} from "@blueprintjs/core";

import { Grid, Row, Col } from "react-flexbox-grid";

import * as ROUTES from "../../constants/routes";

import "./index.css";
import UserTable from "./users_table.js";
import Details from "./details.js";
import Survey from "./survey.js";
import EditEvent from "./edit_event.js";
import Spinner from "react-md-spinner";

import "./index.css";

//https://github.com/captivationsoftware/react-sticky

const detialsInitilization = {
  dates: [""],
  times: [""],
  event_date_formated: new Date(),
  event_type: "",
};

class EventDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirm_status: false,
      loading: false,
      details: detialsInitilization,
      eventId: "",
      eventInstructors: [],
      listUsers: [],
      attendedList: [],
      onEdit: false,
      popoverIsOpen: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  //after or during inflating component
  componentDidMount() {
    const eventid = this.props.match.params.eventId;
    this.setState({ loading: true, eventId: eventid });

    let details = [];

    //load details ...
    this.unsubscribe = this.props.firebase
      .event(eventid)
      .get()
      .then((doc) => {
        let event_date_formated = doc.data().hasOwnProperty("event_date")
          ? this.formateDate(
              doc.data().event_date,
              doc.data().event_date.length
            )
          : {
              date: new Date(),
              start_time: new Date(),
              end_time: new Date(),
            };

        details = {
          id: doc.id,
          event_date_formated: event_date_formated,
          ndays: event_date_formated.length,
          ...doc.data(),
        };

        let name = "";
        let instructors_refs = doc.data().hasOwnProperty("instructors")
          ? doc.data().instructors
          : [];

        instructors_refs.map((ref) => {
          ref
            .get()
            .then((doc) => {
              name = doc.data().firstname + " " + doc.data().familyname;
              let instructors = this.state.eventInstructors;

              instructors.push({
                name: name,
                id: doc.id,
                collection: ref.path.split("/")[0],
              });
              this.setState({
                eventInstructors: instructors,
              });
            })
            .catch((err) => {
              name = "N/A";
              this.setState({
                eventInstructors: [
                  {
                    name: "N/A",
                    id: "N/A",
                    collection: "N/A",
                  },
                ],
              });
              console.log("error: " + err);
            });
        });

        this.setState({
          loading: false,
          details: details,
          confirm_status: details.event_confirmation_status,
        });
      });
  }

  componentWillMount() {
    this.unsubscribe && this.unsubscribe();
  }

  handleDelete = () => {
    let path = ROUTES.HOME;
    this.props.history.push(path);

    this.props.firebase
      .event(this.state.eventId)
      .delete()
      .then(() => {
        console.log("Document successfully deleted!");
      })
      .catch((error) => {
        console.error("Error removing document: ", error);
      });
  };

  getDate = (event_dates) => {
    let s_date = [];

    for (let i = 0; i < event_dates.length; i++) {
      s_date.push(event_dates[i].date.toDateString());
    }

    return s_date;
  };

  getTime = (event_dates) => {
    let s_time = [];

    for (let i = 0; i < event_dates.length; i++) {
      s_time.push(
        event_dates[i].start_time.toLocaleTimeString() +
          " : " +
          event_dates[i].end_time.toLocaleTimeString()
      );
    }

    return s_time;
  };

  formateDate = (eventDate, size) => {
    let newList = [];

    for (let i = 0; i < size; i++) {
      newList.push({
        date: eventDate[i].date.toDate(),
        start_time: eventDate[i].start_time.toDate(),
        end_time: eventDate[i].end_time.toDate(),
      });
    }
    return newList;
  };

  handleSubmit = (values) => {
    console.log(values.eventInstructors, values.eventInstructor);
    this.setState({
      onEdit: !this.state.onEdit,
      details: Object.assign(this.state.details, values.eventDetails),
      eventInstructors: values.eventInstructors,
    });
  };

  handleConfirmation = () => {
    this.setState({ confirm_status: true });
    this.props.firebase.event(this.state.details.id).update({
      event_confirmation_status: !this.state.details.event_confirmation_status,
    });
  };
  handleCancel = () => {
    this.setState({ onEdit: !this.state.onEdit });
  };
  handleEdit = () => {
    this.setState({ onEdit: !this.state.onEdit, isSaved: false });
  };
  handleDeleteWebflow = () => {
    //Are you sure you want to delete this event? You can delete the event from webflow only, delete the whole event.
    this.props.firebase
      .event(this.state.eventId)
      .update({
        event_confirmation_status: false,
      })
      .then(() => {
        console.log("Document successfully deleted!");
      })
      .catch((error) => {
        console.error("Error removing document: ", error);
      });
  };
  render() {
    const { details, loading } = this.state;
    return (
      <div>
        {" "}
        {loading === true ? (
          <Spinner
            size={100}
            style={{ marginTop: "20%", marginLeft: "50%" }}
            singleColor="#1673b5"
          />
        ) : (
          <Grid className=".div-window">
            <Row middle="xs">
              <Col md={9}>
                {" "}
                {this.state.confirm_status ? (
                  <h1>
                    <Icon
                      intent={Intent.SUCCESS}
                      icon="confirm"
                      iconSize={30}
                    />{" "}
                    -{details.event_name}{" "}
                  </h1>
                ) : (
                  <h1>
                    <Icon icon="clipboard" iconSize={30} /> - [Draft-event]:{" "}
                    {details.event_name}{" "}
                  </h1>
                )}{" "}
              </Col>
              {this.state.onEdit ? (
                <Row middle="xs">
                  <Col md={6}>
                    <Button
                      className=".btn"
                      icon="cross"
                      onClick={this.handleCancel}
                    >
                      Cancel{" "}
                    </Button>{" "}
                  </Col>
                </Row>
              ) : (
                <Row middle="xs">
                  <ButtonGroup>
                    <Button
                      icon="upload"
                      onClick={this.handleConfirmation}
                      disabled={this.state.confirm_status ? true : false}
                    >
                      Publish{" "}
                    </Button>

                    <Button
                      className=".btn"
                      icon="edit"
                      intent={Intent.SUCCESS}
                      onClick={this.handleEdit}
                    >
                      Edit{" "}
                    </Button>

                    <Popover
                      isOpen={this.state.popoverIsOpen}
                      canEscapeKeyClose={true}
                      popoverClassName={Classes.POPOVER_CONTENT_SIZING}
                    >
                      <Button
                        className=".btn"
                        icon="trash"
                        intent={Intent.DANGER}
                        onClick={() => {
                          this.setState({ popoverIsOpen: true });
                        }}
                      >
                        Delete{" "}
                      </Button>
                      <div key="text">
                        <h3> Confirm deletion </h3>{" "}
                        <p>
                          Are you sure you want to delete this event ? The event
                          will be deleted from webflow and events.{" "}
                        </p>{" "}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: 15,
                          }}
                        >
                          <Button
                            className={Classes.POPOVER_DISMISS}
                            style={{ marginRight: 10 }}
                            onClick={() => {
                              this.setState({ popoverIsOpen: false });
                            }}
                          >
                            Cancel{" "}
                          </Button>
                          <Button
                            intent={Intent.DANGER}
                            className={Classes.POPOVER_DISMISS}
                            onClick={this.handleDelete}
                          >
                            Delete{" "}
                          </Button>{" "}
                        </div>{" "}
                      </div>{" "}
                    </Popover>
                  </ButtonGroup>{" "}
                </Row>
              )}{" "}
            </Row>{" "}
            <Tabs animate={true} renderActiveTabPanelOnly={true}>
              <Tab
                id="detials"
                title="Event Details"
                panel={
                  this.state.onEdit ? (
                    <EditEvent
                      details={this.state.details}
                      handleSubmit={this.handleSubmit}
                      instructors={this.state.eventInstructors}
                    />
                  ) : (
                    <Details
                      details={details}
                      instructors={this.state.eventInstructors.map(
                        (instructor) => instructor.name
                      )}
                      date={this.getDate(
                        this.state.details.event_date_formated
                      )}
                      time={this.getTime(
                        this.state.details.event_date_formated
                      )}
                    />
                  )
                }
              />{" "}
              <Tab
                id="table"
                title="Registered Users Info"
                panel={
                  <UserTable
                    eventId={details.id}
                    confirmType={this.state.details.confirmation_type}
                    eventDate={details.event_date_formated[0]}
                    form={details.form}
                    isWebinar={details.livestream}
                    eventName={details.event_name}
                  />
                }
              />{" "}
              {/*this.state.details.confirmation_type === "filter" ? (
                <Tab
                  id="form"
                  title="Forms Answers"
                  panel={<Survey eventId={details.id} form={details.form} />}
                />
              ) : (
                console.log("auto-confirm event")
              )*/}
            </Tabs>{" "}
          </Grid>
        )}{" "}
      </div>
    );
  }
}

export default withFirebase(EventDetails);
